(function () {
  var rootSelector = ".product.wd-product-template";
  var popupSelector = ".js-ask-question-popup";
  var buttonSelector = ".js-ask-question-button";
  var activeClass = "is-active";
  var sectionActiveClass = "is-ask-question-popup-active";
  var portaledClass = "wd-ask-question-popup--portaled";

  var getSections = function () {
    return Array.from(document.querySelectorAll(rootSelector));
  };

  var getProductJson = function (section) {
    var jsonEl = section.querySelector("[data-js-product-json]");

    if (!jsonEl) {
      return null;
    }

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return null;
    }
  };

  var getVariantUrl = function (section, productJson) {
    if (!productJson || !productJson.url) {
      return "";
    }

    var variantInput = section.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;

    if (!variantId && productJson.variants && productJson.variants.length) {
      variantId = productJson.variants[0].id;
    }

    if (!variantId) {
      return window.location.origin + productJson.url;
    }

    return (
      window.location.origin + productJson.url + "?variant=" + variantId
    );
  };

  var updateProductUrlField = function (section, popup, sectionId) {
    var input = popup.querySelector(
      "#ask-question-product-url-input--" + sectionId,
    );

    if (!input) {
      return;
    }

    var productJson = getProductJson(section);
    input.value = getVariantUrl(section, productJson);
  };

  var portalPopup = function (popup) {
    if (!popup || popup.parentElement === document.body) {
      return;
    }

    document.body.appendChild(popup);
    popup.classList.add(portaledClass);
  };

  var openPopup = function (section, popup, sectionId) {
    updateProductUrlField(section, popup, sectionId);
    popup.classList.add(activeClass);
    section.classList.add(sectionActiveClass);
    document.body.classList.add("scroll-padding-0");
    document.body.style.overflow = "hidden";
  };

  var closePopup = function (section, popup) {
    popup.classList.remove(activeClass);
    section.classList.remove(sectionActiveClass);
    document.body.classList.remove("scroll-padding-0");
    document.body.style.overflow = "";
  };

  var bindVariantListener = function (section, popup, sectionId) {
    if (!window.themeCore || !window.themeCore.EventBus) {
      return;
    }

    window.themeCore.EventBus.listen(
      "pdp:section-" + sectionId + ":change-variant",
      function () {
        updateProductUrlField(section, popup, sectionId);
      },
    );
  };

  var bindSection = function (section) {
    var sectionId = section.dataset.sectionId;
    var popup =
      document.getElementById("product-ask-question-popup-" + sectionId) ||
      section.querySelector(popupSelector);

    if (!sectionId || !popup) {
      return;
    }

    portalPopup(popup);

    if (section.dataset.wdAskQuestionBound === "true") {
      return;
    }

    section.dataset.wdAskQuestionBound = "true";
    bindVariantListener(section, popup, sectionId);

    section.addEventListener("click", function (event) {
      var openButton = event.target.closest(buttonSelector);

      if (openButton && section.contains(openButton)) {
        event.preventDefault();

        if (popup.classList.contains(activeClass)) {
          closePopup(section, popup);
        } else {
          openPopup(section, popup, sectionId);
        }
      }
    });

    popup.addEventListener("click", function (event) {
      var closeButton = event.target.closest(
        '[data-js-toggle="' + popup.id + '"]',
      );

      if (closeButton) {
        event.preventDefault();
        closePopup(section, popup);
        return;
      }

      if (event.target === popup) {
        closePopup(section, popup);
      }
    });
  };

  var init = function () {
    getSections().forEach(bindSection);
  };

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") {
      return;
    }

    getSections().forEach(function (section) {
      var popup = document.getElementById(
        "product-ask-question-popup-" + section.dataset.sectionId,
      );

      if (popup && popup.classList.contains(activeClass)) {
        closePopup(section, popup);
      }
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  var waitForTheme = function () {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen("product:loaded", init);
      return;
    }

    window.setTimeout(waitForTheme, 50);
  };

  waitForTheme();
})();
